'use client';

import { useEffect, useState } from 'react';

interface ImageWithLoaderProps {
  originalImg: string;
  thumbnail?: string;
}

const ImageWithLoader = ({ originalImg, thumbnail }: ImageWithLoaderProps) => {
  const [isOriginalLoaded, setIsOriginalLoaded] = useState(false);

  useEffect(() => {
    const originalImage = new Image();
    originalImage.src = originalImg;
    originalImage.onload = () => setIsOriginalLoaded(true);
  }, [originalImg]);

  return (
    isOriginalLoaded ? (
      <img src={originalImg} alt="" loading="eager" />
    ) : (
      <img src={thumbnail || originalImg} alt="" loading="eager" />
    )
  );
};
export default ImageWithLoader;
